<mobile-page-content [fullPageWidth]="true">
    <app-mobile-header header [hasSideMenu]="true"></app-mobile-header>

    <app-mobile-side-menu right-menu></app-mobile-side-menu>

    <mobile-module-content *ngIf="!isLoading && annualPlan; else noActiveAnnualPlan" [title]="'AnnualPlan' | translate">
            <div fxLayout="row" fxLayoutAlign="center center">
                <div>
                    <p class="weekly-working-time text-center">{{ 'AnnualPlan_WeeklyWorkingTime' | translate:{'time': annualPlan.weeklyWorkingTime | secondsToDHM | default:'-' } }}</p>
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="start">
                <div fxFlex="100" class="annual-plan-season-goals">
                    <h3>{{ 'title.season_objective' | translate }}</h3>
                    <p>{{ this.annualPlan.comment | default }}</p>
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="start">
                <div fxFlex="100">
                    <app-annual-plan-graph *ngIf="!isLoading && annualPlan && weeks"
                                           [organization]="organization"
                                           [annualPlan]="annualPlan"
                                           [weeks]="weeks"
                                           [annualPlanPhases]="annualPlanPhases"
                                           [annualPlanMacroCycles]="annualPlanMacroCycles"
                                           [showMonths]="true"
                    ></app-annual-plan-graph>
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="start">
                <div fxFlex="100">
                    <div class="plan-legend">
                        <h3>{{ 'Planning' | translate }}</h3>
                        <ul>
                            <li><span class="bullet intensity"></span> {{ 'intensity' | translate }}</li>
                            <li><span class="bullet physical"></span> {{ 'physical' | translate }}</li>
                            <li><span class="bullet sport"></span> {{ 'sport' | translate }}</li>
                        </ul>
                    </div>

                    <div class="plan-legend">
                        <h3>{{ 'Accents' | translate }}</h3>
                        <ul>
                            <li *ngFor="let category of exerciseCategories"><span class="bullet" [ngStyle]="{'background': category.colorHex}"></span> {{ category.name }}</li>
                        </ul>
                    </div>

                    <div class="plan-legend">
                        <h3>{{ 'phases' | translate }}</h3>
                        <ul>
                            <li *ngFor="let phase of phases"><span class="bullet" [ngStyle]="{'background': phase.hexadecimalColor}"></span> {{ phase.name }}</li>
                        </ul>
                    </div>
                </div>
            </div>

    </mobile-module-content>
    <ng-template #noActiveAnnualPlan>
        <span class="no-active-annual-plan-message">{{ 'NoActiveAnnualPlanMessage'|translate }}</span>
    </ng-template>
</mobile-page-content>

